import React from 'react';
import { FormCheckbox } from '@catalogo/theme-form-builder/src/components/checkbox';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';
import { IServicesPDP } from './types';
import * as Styled from './styles';

const ServicesPDP: React.FC<IServicesPDP> = props => {
  const {
    serviceId,
    isServiceSelected,
    price,
    serviceName,
    numberOfInstallments,
    history,
    modalHash,
    ServiceIcon,
    serviceTextPrefix,
    serviceText,
    serviceLinkText,
    toggleServiceSelect,
  } = props;

  if (!serviceId) {
    return <></>;
  }

  return (
    <Styled.Container>
      <Styled.Title>eeei, aproveite também!</Styled.Title>
      <Styled.Box $isCheckboxSelected={isServiceSelected}>
        <Styled.CheckboxContainer>
          <FormCheckbox onClick={toggleServiceSelect(serviceId)} />
        </Styled.CheckboxContainer>
        <Styled.IconUI>
          <ServiceIcon />
        </Styled.IconUI>
        <Styled.Text>
          {serviceTextPrefix} <Styled.ServiceName>{serviceText}</Styled.ServiceName> em até {numberOfInstallments}x de{' '}
          <Styled.PriceUI>{price}</Styled.PriceUI>
          &nbsp;s/ juros.
          <Styled.BoxAnchor onClick={replaceUrlParams(history, modalHash, false, { oneShotDispatch: true })}>
            {serviceLinkText}
          </Styled.BoxAnchor>
        </Styled.Text>
      </Styled.Box>
      {isServiceSelected && (
        <Styled.Disclaimer>
          ao clicar em comprar você aceita os termos e condições:{' '}
          <Styled.DisclaimerAnchor onClick={replaceUrlParams(history, modalHash, false, { oneShotDispatch: true })}>
            {serviceName}
          </Styled.DisclaimerAnchor>
          &nbsp;e&nbsp;
          <Styled.DisclaimerAnchor
            onClick={replaceUrlParams(history, '#modal-hiring-policy', false, {
              oneShotDispatch: true,
            })}
          >
            política de contratação.
          </Styled.DisclaimerAnchor>
        </Styled.Disclaimer>
      )}
    </Styled.Container>
  );
};

export default ServicesPDP;
